export const Bio = {
  name: "PREX VERDEFLOR",
  roles: [
    "Front-End Developer",
    "Web Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  github: "https://github.com/prexjhonverdeflor",
  resume: "https://drive.google.com/file/d/1oQatWcLPjYfOVDDQmij3UFpBhZL0Dvc6/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/prex-jhon-verdeflor-586a46200/",
  twitter: "https://x.com/PVerdeflor12404",
  insta: "https://www.instagram.com/prexverdeflor/",
  email: "https://mail.google.com/mail/u/0/#inbox?compose=DmwnWrRnZFQCGmNPkSxbcHhlVqxlkPfRvPFTRkcbxPFqbgzdCsSSvLhkRjpmSNCjLmBxqqwmvSsB",
};

export const skills = [

  {
    name: "HTML",
    image: "/skills/html.png"
  },
  {
    name: "CSS",
    image: "/skills/css.svg"
  },
  {
    name: "JavaScript",
    image: "/skills/javascript.png"
  },
  {
    name: "React Js",
    image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K"
  },
  {
    name: "Vue Js",
    image: "/skills/vue.svg"
  },
  {
    name: "TypeScript",
    image: "/skills/typescript.svg"
  },
  {
    name: "Bootstrap",
    image: "/skills/bootstrap.png"
  },
  {
    name: "Tailwind",
    image: "/skills/tailwind.svg"
  },
  {
    name: "GSAP",
    image: "/skills/gsap.png"
  },
  {
    name: "Three Js",
    image: "/skills/threejs.png"
  },
  {
    name: "Python",
    image: "/skills/python.svg"
  },
  {
    name: "Django",
    image: "/skills/django.png"
  },
  {
    name: "PHP",
    image: "/skills/php.png"
  },
  {
    name: "Java",
    image: "/skills/java.svg"
  },
  {
    name: "MySQL",
    image: "/skills/mysql.svg"
  },
  {
    name: "Wordpress",
    image: "/skills/wordpress.png"
  },
  {
    name: "Shopify",
    image: "/skills/shopify.png"
  },
  {
    name: "Figma",
    image: "/skills/figma.png"
  },
  {
    name: "Canva",
    image: "/skills/canva.png"
  },
  {
    name: "Git",
    image: "/skills/git.png"
  },
  {
    name: "Gitlab",
    image: "/skills/gitlab.png"
  },
  {
    name: "SourceTree",
    image: "/skills/sourcetree.svg"
  },
];



export const Links = {
  link1: "https://prexverdeflor.vercel.app/",
  github1: "https://github.com/prexjhonverdeflor",

  link2: "example.com",
  github2: "https://github.com/prexjhonverdeflor/DjangoCRUD",

  link3: "https://saintdominicdeguzmanparish.sticapstone.com/",
  github3: "https://github.com/prexjhonverdeflor",

  link4: "https://3d-toyota.vercel.app/",
  github4: "https://github.com/prexjhonverdeflor/3d-toyota",

};



export const data = [
  {
    title: "DigiPlus",
    description: "Developed and maintained responsive web applications using Vue 2 and 3, Pinia, Vue Router, JavaScript, TypeScript, HTML, CSS/SCSS, Element Plus, and Git.",
    speed: 0.5
  },
  {
      title: "CAMALIG BANK",
      description: "Developed a Payment Portal using Python and Django framework, enhancing the bank's online transaction and improving user experience.",
      speed: 0.5
  },
  {
      title: "DENR 5",
      description: "Managed and secure network infrastructure, configuring routers, switches, firewalls, and VPNs to ensure efficient communication between servers and applications.",
      speed: 0.5
  },

];

export const newData = [
  {
      title: "STI COLLEGE",
      description: "Acquire skills in programming, database management, network administration, and web development, with practical experience from internships and hands-on projects.",
      speed: 1.0
  },
  {
      title: "STI SENIOR HIGH",
      description: "Acquire skills in programming and web development, with hands-on experience in various languages and frameworks, enabling me to create functional applications.",
      speed: 1.5
  },
  {
      title: "BICOL COLLEGE",
      description: "Provided me with a strong foundation of knowledge and skills, preparing me for future academic and career endeavors, ensuring to excel in my chosen field.",
      speed: 1.5
  }

];


